module.exports = __webpack_public_path__ + "img/EldenCerso.2d7b99c5.png";